(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-sfa", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-sfa?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSfa",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa.html",
                        controller:
                            "LebaniegoYearContactosSectorSfaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-sfa.new", {
                parent: "lebaniego-contacts-sector-sfa",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa-new.html",
                        controller: "LebaniegoYearContactosSectorSfaNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-sfa"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-sfa",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-sfa.edit", {
                parent: "lebaniego-contacts-sector-sfa",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSfa"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa-detail.html",
                        controller: "LebaniegoYearContactosSectorSfaDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-sfa"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorSfa",
                        function ($stateParams, LebaniegoYearContactosSectorSfa) {
                            return LebaniegoYearContactosSectorSfa.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-sfa",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();